<template>   
  <div class="form-group">
    <label>{{ label }}</label>
    <input 
      class="form-control"
      v-bind:value="value"
      v-on:input="$emit('update:value', $event.target.value)"
    >
  </div>
</template>


<script>
export default {
  props: ['value', 'label', 'name']
};
</script>